module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0107.jpg?v=4d8c480b";